/* eslint-disable react/prop-types */
import {
	Autocomplete,
	Box,
	Button,
	CircularProgress,
	FormControl,
	Grid,
	IconButton,
	InputAdornment,
	MenuItem,
	Select,
	Snackbar,
	Stack,
	TextField,
	Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import BrandedLoader from '../../../components/BrandedLoader/BrandedLoader';
import '../Dashboard.css';
import Schedular from './Schedular';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AddIcon from '@mui/icons-material/Add';
import Modal from '@mui/material/Modal';
import Tooltip from '@mui/material/Tooltip';
import { DatePicker, MobileDatePicker } from '@mui/x-date-pickers';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
	addAppointment,
	getAppointment,
	getLocation,
	getPatientList,
	getPracticeStaff,
	updateAppointment,
} from '../../../services/api/apiManager';

import { useStateValue } from '../../../services/state/State';
import dayjs from 'dayjs';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {
	Cancel,
	Delete,
	Edit,
	Refresh,
	Update,
	WindowSharp,
} from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import { useNavigate } from 'react-router';
const colors = ['#CFECFF', '#403C3C', '#FDF1DB'];

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	background: 'white',
	fontFamily: 'Poppins',
	borderRadius: '10px',
	width: 'min(920px, calc(100vw - 48px))',
	border: '1px solid #dce6f3',
	boxShadow: '0 10px 30px rgba(16, 24, 40, 0.14)',
	outline: 'none',
};

function ScheduleAppointment(props) {
	const routerNavigator = useNavigate();

	const [{ patients, locations, practice }, dispatch] = useStateValue();
	const practiceId = localStorage.getItem('practice_id');
	const [invalidInfo, setInvalidInfo] = useState(false);
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [postSucessfully, setPostSucessfully] = useState(true);
	const [updateAppointmentSnackbar, setupdateAppointmentSnackbar] =
		useState(false);
	const [deleteAppointment, setDeleteAppointment] = useState(false);
	const defaultTheme = createTheme();
	const [selectedDate, setselectedDate] = useState(dayjs(new Date()));
	const [patientList, setPatientList] = useState([]);
	const [filterLocation, setFilterLocation] = React.useState('');
	const [week, setWeek] = React.useState('');
	const [open, setOpen] = React.useState(false);
	const [appointmentList, setAppointmentList] = useState([]);
	const [staffList, setStaffList] = useState([]);
	const [location, setLocation] = useState([]);
	const [provider, setProvider] = React.useState('');
	const [selectedFilterDate, setSelectedFilterDate] = useState(null);
	const [loading, setLoading] = useState(false);
	const practice_id = localStorage.getItem('practice_id');
	const [filteredAppointments, setFilteredAppointments] =
		useState(appointmentList);
	const [rows, setRows] = useState([]);
	const [appointment, setappoitment] = useState({
		// practice_id: practice_id,
		patient_id: '',
		provider_id: '',
		location_id: '',
		AppointmentDate: dayjs(selectedDate).format('YYYY-MM-DDTHH:mm:ss'),
		Status: '',
		Reason: '',
	});
	// update apppointments states are here
	const [updateDate, setUpdateDate] = useState(dayjs(new Date()));
	const [appointmentID, setAppointmentID] = useState(0);
	const [updateAppointmentData, setUpdateAppointmentData] = useState({
		patient_id: '',
		provider_id: '',
		location_id: '',
		AppointmentDate: '',
		Status: '',
		Reason: '',
	});
	const [updateModalopen, setUpdateModalopen] = React.useState(false);
	const updateModalhandleOpen = (data) => {
		// when modal opening all values will be according to patient appointment
		setUpdateAppointmentData({
			patient_id: data?.row?.patient_id,
			// patient: data?.row?.patient?.name,
			provider_id: data?.row?.provider_id,
			location_id: data?.row?.location_id,
			//because update data is coming from datagrid and date and time values are separated from each other thats why we are using this logic
			AppointmentDate: dayjs(
				dayjs(
					data?.row?.ApptDate + 'T' + data?.row?.ApptTime.slice(0, 8),
					'MM-DD-YYYYTHH:mm:ss'
				).toDate()
			).format('YYYY-MM-DDTHH:mm:ss'),
			Status: data?.row?.Status,
			Reason: data?.row?.Reason,
		});
		setUpdateDate(
			//because update data is coming from datagrid and date and time values are separated from each other thats why we are using this logic
			dayjs(
				dayjs(
					data?.row?.ApptDate + 'T' + data?.row?.ApptTime.slice(0, 8),
					'MM-DD-YYYYTHH:mm:ss'
				)
					.toDate()
					.toString()
			)
		);
		setAppointmentID(data?.row?.id);
		setUpdateModalopen(true);
	};
	const updateModalhandleClose = () => setUpdateModalopen(false);
	// Modal Delete with these state values are shown in delete Modal
	const [openDeleteModal, setOpenDeleteModal] = useState({
		deleteModalOpen: false,
		deletingId: '',
		deletingName: '',
		deletingReason: '',
	});
	const handleOpenDeleteModal = (data) => {
		setOpenDeleteModal({
			deleteModalOpen: true,
			deletingId: data?.row?.id,
			deletingName: data?.row?.name,
			deletingReason: data?.row?.Reason,
		});
	};
	const handleCloseDeleteModal = () => {
		setOpenDeleteModal({
			deleteModalOpen: false,
			deletingId: '',
			deletingName: '',
			deletingReason: '',
		});
	};

	const navigateToPatientPage = (cellValues) => {
		routerNavigator('/Edit_Patient', {
			state: {
				id: cellValues?.row?.patient_id,
				id1: cellValues?.row?.id,
				id2: cellValues?.row?.admissionid,
				id3: cellValues?.row?.LstVistId,
			},
		});
	};
	const filterFieldSx = {
		'& .MuiInputBase-root': {
			height: 40,
			borderRadius: '6px',
			backgroundColor: '#fff',
			fontFamily: 'Poppins',
			fontSize: '13px',
		},
		'& .MuiInputLabel-root': {
			display: 'none',
		},
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: '#d6e2f2',
		},
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: '#b9cbe3',
		},
		'& .Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: '#2E68BA',
			borderWidth: '1px',
		},
		'& .MuiInputBase-input': {
			color: '#122b55',
			fontSize: '13px',
			padding: '9px 12px',
		},
	};
	const filterLabelSx = {
		mb: 0.5,
		fontFamily: 'Poppins',
		fontSize: '12px',
		fontWeight: 600,
		color: '#172d58',
	};
	const modalLabelSx = {
		fontFamily: 'Poppins',
		fontSize: '13px',
		fontWeight: 600,
		color: '#172d58',
		mb: 0.5,
	};
	const modalControlSx = {
		width: '100%',
		'& .MuiInputBase-root': {
			height: 50,
			minHeight: 50,
			borderRadius: '8px',
			backgroundColor: '#fff',
			fontFamily: 'Poppins',
			fontSize: '13px',
		},
		'& .MuiFormControl-root': {
			width: '100%',
		},
		'& .MuiAutocomplete-inputRoot': {
			height: '50px !important',
			minHeight: '50px !important',
			paddingTop: '0 !important',
			paddingBottom: '0 !important',
		},
		'& .MuiInputBase-input': {
			height: 'auto',
			padding: '12px 14px',
			color: '#122b55',
			fontSize: '13px',
			boxSizing: 'border-box',
		},
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: '#d6e2f2',
		},
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: '#b9cbe3',
		},
		'& .Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: '#2E68BA',
			borderWidth: '1px',
		},
	};
	const modalMenuProps = {
		PaperProps: {
			sx: {
				mt: 0.5,
				maxHeight: 260,
				borderRadius: '8px',
				boxShadow: '0 8px 24px rgba(16, 24, 40, 0.14)',
				'& .MuiMenuItem-root': {
					fontFamily: 'Poppins',
					fontSize: '13px',
					minHeight: 34,
					py: 0.75,
				},
				'& .MuiMenuItem-root.Mui-selected': {
					backgroundColor: '#edf5ff',
				},
				'& .MuiMenuItem-root.Mui-selected:hover': {
					backgroundColor: '#e5f0ff',
				},
			},
		},
	};
	const gridSx = {
		border: '1px solid #dce6f3',
		borderRadius: '8px',
		backgroundColor: '#fff',
		fontFamily: 'Poppins',
		color: '#172d58',
		'& .MuiDataGrid-columnHeader': {
			backgroundColor: '#f7f9fc',
			color: '#172d58',
			fontFamily: 'Poppins',
			fontWeight: 700,
			fontSize: '12px',
			overflow: 'hidden',
		},
		'& .MuiDataGrid-columnHeaders': {
			borderBottom: '1px solid #e6edf7',
		},
		'& .MuiDataGrid-cell': {
			borderBottom: '1px solid #edf2f8',
			fontFamily: 'Poppins',
			fontSize: '12px',
			fontWeight: 500,
			color: '#172d58',
			outline: 'none',
		},
		'& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus': {
			outline: 'none',
		},
		'& .MuiDataGrid-row:hover': {
			backgroundColor: '#f8fbff',
		},
		'& .MuiDataGrid-footerContainer': {
			justifyContent: 'flex-end',
			backgroundColor: '#fff',
			borderTop: '1px solid #e6edf7',
			minHeight: '52px',
			px: 2,
		},
		'& .MuiTablePagination-toolbar': {
			minHeight: '52px',
			gap: '8px',
			px: 0,
		},
		'& .MuiInputBase-root': {
			border: '1px solid #dfe7f3',
			width: '58px',
			height: '34px',
			borderRadius: '6px',
			backgroundColor: 'white',
			fontFamily: 'Poppins',
			fontSize: '12px',
		},
		'& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
			fontFamily: 'Poppins',
			fontSize: '12px',
			color: '#172d58',
			fontWeight: 600,
		},
		'& .MuiTablePagination-actions': {
			display: 'flex',
			gap: '8px',
			ml: 1,
		},
		'& .MuiTablePagination-actions .MuiIconButton-root': {
			width: 34,
			height: 34,
			border: '1px solid #e4ebf6',
			borderRadius: '50%',
			backgroundColor: '#fff',
			color: '#1f66ff',
			p: 0,
		},
		'& .MuiTablePagination-actions .MuiIconButton-root:hover': {
			backgroundColor: '#f4f8ff',
		},
		'& .MuiTablePagination-actions .MuiIconButton-root.Mui-disabled': {
			color: '#b9c7dc',
			borderColor: '#e4ebf6',
			backgroundColor: '#fff',
		},
		'& .MuiDataGrid-virtualScroller': {
			scrollbarWidth: 'thin',
		},
		'& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
			width: '6px',
			height: '6px',
		},
		'& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
			backgroundColor: '#c7d4e8',
			borderRadius: '999px',
		},
	};
	const renderStatusPill = (status) => {
		const config =
			status === 'C'
				? { label: 'Completed', color: '#09913d', bg: '#eaf8ef' }
				: status === 'D'
					? { label: 'Dismissed', color: '#e53935', bg: '#ffecec' }
					: status === 'O'
						? { label: 'Other', color: '#606b7b', bg: '#f1f4f8' }
						: { label: 'Pending', color: '#ff9800', bg: '#fff7e7' };

		return (
			<Box
				sx={{
					display: 'inline-flex',
					alignItems: 'center',
					gap: 0.6,
					px: 1.1,
					height: 24,
					borderRadius: '999px',
					bgcolor: config.bg,
					color: config.color,
					fontSize: '11px',
					fontWeight: 700,
					fontFamily: 'Poppins',
				}}
			>
				<Box
					component="span"
					sx={{
						width: 6,
						height: 6,
						borderRadius: '50%',
						bgcolor: config.color,
					}}
				/>
				{config.label}
			</Box>
		);
	};

	useEffect(() => {
		// Sort appointments by ID in descending order
		const sortedAppointments = filteredAppointments.sort((a, b) => b.id - a.id);

		// Map appointments to rows
		const appointmentRows = sortedAppointments.map((data) => ({
			id: data.id,
			ApptDate: moment(data.AppointmentDate).format('MM-DD-YYYY'),
			ApptTime: moment(data.AppointmentDate).format('h:mm:ss A'),
			Reason: data.Reason,
			Location: data?.location?.Name,
			location_id: data?.location_id,
			Status: data?.Status,
			patient_id: data.patient_id,
			provider_id: data?.provider_id,
			name: data?.patient?.Lname + ' , ' + data?.patient?.Fname,
			provider: data?.provider?.Lname + ' , ' + data?.provider?.Fname,
		}));

		// Update the rows state
		setRows(appointmentRows);
	}, [filteredAppointments]);

	const columns = [
		{ field: 'id', headerName: 'ID', width: 70 },
		{
			field: 'name',
			headerName: 'Patient Name',
			minWidth: 180,
			flex: 1,
			renderCell: (cellValues) => {
				return (
					<div>
						<p
							style={{ cursor: 'pointer', margin: 0, color: '#172d58' }}
							onClick={() => {
								navigateToPatientPage(cellValues);
							}}
						>
							<u>{cellValues.value}</u>&nbsp;
							{/* <Tooltip
								title={
									!cellValues?.row?.Admission_date
										? 'No Admission Created'
										: 'Admission Created'
								}
							>
								<InfoIcon sx={{ fontSize: '16px', color: 'red' }} />
							</Tooltip> */}
						</p>
					</div>
				);
			},
		},
		{
			field: 'provider',
			headerName: 'Provider Name',
			minWidth: 170,
			flex: 1,
		},
		{
			field: 'ApptDate',
			headerName: 'Appointment Date',
			minWidth: 150,
			flex: 0.9,
		},
		{
			field: 'ApptTime',
			headerName: 'Appointment Time',
			minWidth: 150,
			flex: 0.9,
			renderCell: (params) => {
				const apptTime_AMPM = params?.value;
				return (
					<>
						<span>{dayjs(apptTime_AMPM, 'HH:mm:ss').format('hh:mm:ss A')}</span>
					</>
				);
			},
		},
		{
			field: 'Reason',
			headerName: 'Reason',
			minWidth: 180,
			flex: 1,
		},
		{
			field: 'Location',
			headerName: 'Location',
			minWidth: 150,
			flex: 0.9,
		},
		{
			field: 'Status',
			headerName: 'Status',
			minWidth: 130,
			flex: 0.7,
			renderCell: (params) => {
				return renderStatusPill(params.value);
			},
		},
		{
			sortable: false,
			disableColumnMenu: true,
			field: 'Actions',
			headerName: 'Actions',
			width: 130,
			renderCell: (rows) => {
				return (
					<div>
						<IconButton
							onClick={() => {
								updateModalhandleOpen(rows);
							}}
							sx={{
								cursor: 'pointer',
								color: '#0e4374',
								fontSize: '20px',
							}}
						>
							<EditIcon fontSize="small" />
						</IconButton>
						<IconButton
							onClick={() => {
								handleOpenDeleteModal(rows);
							}}
							sx={{
								cursor: 'pointer',
								color: 'red',
								fontSize: '20px',
							}}
						>
							<DeleteIcon fontSize="small" />
						</IconButton>
					</div>
				);
			},
		},
	];
	// ROWS DATA for DATAGRID
	const rows1 =
		filteredAppointments &&
		filteredAppointments.map((data, index) => ({
			id: data.id,
			ApptDate: moment(data.AppointmentDate).format('MM-DD-YYYY'),
			ApptTime: dayjs(data.AppointmentDate).format('HH:mm:ss'),
			Reason: data.Reason,
			Location: data?.location?.Name,
			location_id: data?.location_id,
			Status: data?.Status,
			patient_id: data.patient_id,
			provider_id: data?.provider_id,
			name: data?.patient?.Lname + ' , ' + data?.patient?.Fname,
			provider: data?.provider?.Lname + ' , ' + data?.provider?.Fname,
		}));

	const handleProvider = (event) => {
		setProvider(event.target.value);

		const filterAppointmentss = appointmentList?.filter((appointment) => {
			if (
				filterLocation === '' &&
				selectedFilterDate === null &&
				event.target.value !== ''
			) {
				return appointment.provider_id === parseInt(event.target.value);
			} else if (
				event.target.value === '' &&
				selectedFilterDate === null &&
				filterLocation !== ''
			) {
				return appointment?.location_id === parseInt(filterLocation);
			} else if (
				event.target.value !== '' &&
				filterLocation !== '' &&
				selectedFilterDate === null
			) {
				return (
					appointment.provider_id === parseInt(event.target.value) &&
					appointment.location_id === parseInt(filterLocation)
				);
			} else if (
				filterLocation === '' &&
				event.target.value !== '' &&
				selectedFilterDate !== null
			) {
				return (
					appointment?.provider_id === parseInt(event.target.value) &&
					new Date(appointment.AppointmentDate).toISOString().split('T')[0] ===
						selectedFilterDate.format('YYYY-MM-DD')
				);
			} else if (
				filterLocation !== '' &&
				event.target.value !== '' &&
				selectedFilterDate !== null
			) {
				return (
					appointment?.provider_id === parseInt(event.target.value) &&
					new Date(appointment.AppointmentDate).toISOString().split('T')[0] ===
						selectedFilterDate.format('YYYY-MM-DD') &&
					appointment?.location_id === parseInt(filterLocation)
				);
			} else if (
				event.target.value === '' &&
				filterLocation === '' &&
				selectedFilterDate !== null
			) {
				return (
					new Date(appointment.AppointmentDate).toISOString().split('T')[0] ===
					selectedFilterDate.format('YYYY-MM-DD')
				);
			} else if (
				event.target.value === '' &&
				filterLocation !== '' &&
				selectedFilterDate !== null
			) {
				return (
					new Date(appointment.AppointmentDate).toISOString().split('T')[0] ===
						selectedFilterDate.format('YYYY-MM-DD') &&
					appointment?.location_id === parseInt(filterLocation)
				);
			} else if (event.target.value === '' && filterLocation === '') {
				return appointmentList;
			}
		});
		setFilteredAppointments(filterAppointmentss);
	};

	const handleCloseSnackbar = () => setOpenSnackbar(false);
	const handleFilterLocation = (e) => {
		setFilterLocation(e.target.value);
		const filterAppointmentss = appointmentList?.filter((appointment) => {
			if (
				provider === '' &&
				selectedFilterDate === null &&
				e.target.value !== ''
			) {
				return appointment?.location_id === parseInt(e.target.value);
			} else if (
				e.target.value === '' &&
				selectedFilterDate === null &&
				provider !== ''
			) {
				return appointment?.provider_id === parseInt(provider);
			} else if (
				e.target.value !== '' &&
				provider !== '' &&
				selectedFilterDate === null
			) {
				return (
					appointment?.location_id === parseInt(e.target.value) &&
					appointment?.provider_id === parseInt(provider)
				);
			} else if (
				e.target.value !== '' &&
				provider === '' &&
				selectedFilterDate !== null
			) {
				return (
					new Date(appointment.AppointmentDate).toISOString().split('T')[0] ===
						selectedFilterDate.format('YYYY-MM-DD') &&
					appointment?.location_id === parseInt(e.target.value)
				);
			} else if (
				e.target.value !== '' &&
				provider !== '' &&
				selectedFilterDate !== null
			) {
				return (
					appointment?.provider_id === parseInt(provider) &&
					new Date(appointment.AppointmentDate).toISOString().split('T')[0] ===
						selectedFilterDate.format('YYYY-MM-DD') &&
					appointment?.location_id === parseInt(e.target.value)
				);
			} else if (
				e.target.value === '' &&
				provider === '' &&
				selectedFilterDate !== null
			) {
				return (
					new Date(appointment.AppointmentDate).toISOString().split('T')[0] ===
					selectedFilterDate.format('YYYY-MM-DD')
				);
			} else if (e.target.value === '' && provider === '') {
				return appointmentList;
			}
		});

		setFilteredAppointments(filterAppointmentss);
	};

	const handleDateChange = (date) => {
		const dataSelect = date;
		setSelectedFilterDate(dataSelect);

		const filterAppointments = dataSelect
			? appointmentList?.filter((appointment) => {
					if (provider !== '' && dataSelect !== null) {
						const formattedAppointmentDate = new Date(
							appointment.AppointmentDate
						)
							.toISOString()
							.split('T')[0];

						return (
							formattedAppointmentDate === dataSelect.format('YYYY-MM-DD') &&
							appointment?.provider_id === parseInt(provider)
						);
					} else if (filterLocation !== '' && dataSelect !== null) {
						const formattedAppointmentDate = new Date(
							appointment.AppointmentDate
						)
							.toISOString()
							.split('T')[0];

						return (
							formattedAppointmentDate === dataSelect.format('YYYY-MM-DD') &&
							appointment?.location_id === parseInt(filterLocation)
						);
					} else if (provider === '' && dataSelect !== null) {
						const formattedAppointmentDate = new Date(
							appointment.AppointmentDate
						)
							.toISOString()
							.split('T')[0];

						return formattedAppointmentDate === dataSelect.format('YYYY-MM-DD');
					}
				})
			: appointmentList;

		setFilteredAppointments(filterAppointments);
	};

	const getLocationsData = async () => {
		const resp = await getLocation();
		if (resp?.status === 200) {
			setLocation(resp?.data);
		}
	};
	const fetchAppointments = async () => {
		setLoading(true);
		const res = await getAppointment();
		if (res?.status === 200) {
			// setAppointmentList(res?.data);
			setAppointmentList(
				res?.data?.filter((items) => items?.patient?.practice_id == practiceId)
			);
		} else if (res?.status === undefined) {
			setPostSucessfully(false);
			setOpenSnackbar(true);
		}
		setLoading(false);
	};

	const fetchPatientList = async (id) => {
		const resp = await getPatientList(id);
		if (resp.status === 200) {
			setPatientList(resp?.data);
		} else {
			setPatientList([]);
		}
	};

	const fetchPracticeStaff = async () => {
		const res = await getPracticeStaff();
		if (res && res.data && res.data.length > 0) {
			setStaffList(res.data);
		} else {
			setStaffList([]);
		}
	};
	// for adding new appointments
	const addNewAppointment = async (data) => {
		const resp = await addAppointment(data);
		if (resp.status === 201) {
			setPostSucessfully(true);
			setOpenSnackbar(true);
			handleCloseModal();
			setappoitment({
				patient_id: '',
				provider_id: '',
				AppointmentDate: dayjs(selectedDate),
				Status: 'P',
				location_id: '',
				Reason: '',
			});
			fetchAppointments();
			setselectedDate(dayjs(new Date()));
		} else if (resp?.status === undefined) {
			setPostSucessfully(false);
			setOpenSnackbar(true);
		}
	};
	// for updating appointment
	const updateAppointmentInfo = async (id, data) => {
		const resp = await updateAppointment(id, data);
		if (resp?.status === 200) {
			setPostSucessfully(true);
			updateModalhandleClose();
			setupdateAppointmentSnackbar(true);
			if (resp?.data?.Deleted === true) {
				setDeleteAppointment(true);
				setOpenDeleteModal(false);
			}
			setOpenSnackbar(true);
			fetchAppointments();
		} else if (resp?.status === undefined) {
			setPostSucessfully(false);
			setOpenSnackbar(true);
		}
		setSelectedFilterDate(null);
		setProvider('');
		setFilterLocation('');
	};

	const mappingPatientsList =
		patients &&
		patients?.map((row) => ({
			patientId: row.patient_id,
			patientName: row.Name,
		}));

	const mappingProviderList =
		staffList &&
		staffList?.map((row) => ({
			name: row?.Lname + ' ' + row?.Fname,
			providerId: row.id,
		}));

	const handleOpen = () => setOpen(true);
	const handleCloseModal = () => {
		setappoitment({
			patient_id: '',
			provider_id: '',
			AppointmentDate: dayjs(selectedDate),
			location_id: '',
			Status: 'P',
			Reason: '',
		});
		setOpen(false);
	};

	useEffect(() => {
		fetchAppointments();
		getLocationsData();
		fetchPatientList(practiceId);
		fetchPracticeStaff();
	}, []);

	useEffect(() => {
		if (appointmentList) {
			setFilteredAppointments(appointmentList);
		}
	}, [appointmentList]);

	const handleReset = () => {
		setProvider('');
		setFilterLocation('');
		setSelectedFilterDate(null);
		setFilteredAppointments(appointmentList);
	};
	useEffect(() => {
		fetchAppointments();
	}, [props?.reRenderFromParent]);
	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid
				container
				component="main"
				sx={{
					bgcolor: '#f6f8fb',
					p: 1,
					fontFamily: 'Poppins',
					minHeight: 'calc(100vh - 46px)',
				}}
			>
				{loading ? ( // Display loading indicator if loading is true
					<BrandedLoader
						title="Loading appointments"
						text="Preparing appointment schedule"
					/>
				) : (
					<Grid
						item
						container
						xs={12}
						lg={12}
						xl={12}
						md={12}
						sm={12}
						// sx={{ padding: ' 0px 10px 0px 0px' }}
					>
						<Grid
							item
							container
							xs={12}
							lg={12}
							xl={12}
							md={12}
							sm={12}
							sx={{ dislay: 'flex', flexDirection: 'column', gap: 1 }}
						>
							<Grid
								container
								item
								sx={{
									p: 1.5,
									background: '#fff',
									border: '1px solid #dce6f3',
									borderRadius: '8px',
									display: 'flex',
									alignItems: 'flex-end',
									gap: 1.5,
									flexWrap: 'wrap',
								}}
							>
								<Grid
									item
									xs={12}
									sm={6}
									md={3}
									xl={3}
									lg={3}
									sx={{ p: 0, minWidth: 210 }}
								>
									<Box>
										<Typography sx={filterLabelSx}>Provider</Typography>
										<FormControl size="small" fullWidth>
											<Select
												defaultValue=""
												name="providerFilter"
												value={provider}
												onChange={handleProvider}
												inputProps={{ 'aria-label': 'Without label' }}
												displayEmpty
												sx={filterFieldSx}
												MenuProps={{
													PaperProps: {
														style: {
															maxHeight: 260,
														},
													},
												}}
											>
												<MenuItem value="" sx={{ color: '#8a9ab5' }}>
													Select provider
												</MenuItem>
												{mappingProviderList &&
													mappingProviderList.length > 0 &&
													mappingProviderList.map((pl, index) => (
														<MenuItem key={index} value={pl.providerId}>
															{pl?.name}
														</MenuItem>
													))}
											</Select>
										</FormControl>
									</Box>
								</Grid>
								<Grid
									item
									xs={12}
									sm={6}
									md={3}
									xl={3}
									lg={3}
									sx={{ p: 0, minWidth: 210 }}
								>
									<Box>
										<Typography sx={filterLabelSx}>Location</Typography>
										<FormControl
											size="small"
											fullWidth
											inputProps={{ 'aria-label': 'Without label' }}
										>
											<Select
												defaultValue=""
												name="locationFilterID"
												inputProps={{ 'aria-label': 'Without label' }}
												MenuProps={{
													PaperProps: {
														style: {
															maxHeight: 260,
														},
													},
												}}
												value={filterLocation}
												onChange={handleFilterLocation}
												displayEmpty
												sx={filterFieldSx}
											>
												<MenuItem value="" sx={{ color: '#8a9ab5' }}>
													Select location
												</MenuItem>
												{location?.map((items, index) => {
													return (
														<MenuItem key={index} value={items?.id}>
															{items?.Name}
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>
									</Box>
								</Grid>
								<Grid
									item
									xs={12}
									sm={6}
									md={3}
									xl={3}
									lg={3}
									sx={{ p: 0, minWidth: 210 }}
								>
									<Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1 }}>
										<Box sx={{ flex: 1 }}>
											<Typography sx={filterLabelSx}>Date</Typography>
										<LocalizationProvider fullWidth dateAdapter={AdapterDayjs}>
											<DemoContainer
												components={['DatePicker']}
												sx={{ p: 0, overflow: 'visible', width: '100%' }}
											>
												<DemoItem sx={{ width: '100%' }}>
													<DatePicker
														sx={{ width: '100%' }}
														slotProps={{
															textField: {
																size: 'small',
																placeholder: 'MM/DD/YYYY',
																sx: filterFieldSx,
															},
														}}
														value={selectedFilterDate}
														onChange={handleDateChange}
													/>
												</DemoItem>
											</DemoContainer>
										</LocalizationProvider>
										</Box>
										<Tooltip title="Reset Filters" placement="right">
											<Button
												onClick={handleReset}
												variant="contained"
												size="medium"
												sx={{
													minWidth: 40,
													width: 40,
													height: 40,
													borderRadius: '6px',
													bgcolor: '#2e7d32',
													boxShadow: 'none',
													'&:hover': { bgcolor: '#1f6c29' },
												}}
											>
												<Refresh />
											</Button>
										</Tooltip>
									</Box>
								</Grid>
								<Grid
									item
									xs={12}
									sm={6}
									md={2}
									xl={2}
									lg={2}
									sx={{
										display: 'flex',
										justifyContent: 'flex-end',
										alignItems: 'center',
										p: 0,
										ml: 'auto',
									}}
								>
									<Button
										onClick={handleOpen}
										startIcon={<AddIcon />}
										sx={{
											color: 'white',
											background: '#2E68BA',
											fontWeight: 600,
											fontFamily: 'Poppins',
											height: 40,
											borderRadius: '6px',
											px: 2.5,
											whiteSpace: 'nowrap',
											boxShadow: '0 2px 6px rgba(46, 104, 186, 0.25)',
											'&:hover': {
												background: '#265aa8',
											},
										}}
									>
										Add
									</Button>
								</Grid>
							</Grid>
						</Grid>

						<Box
							sx={{
								height: {
									xl: 620,
									lg: 560,
									md: 540,
									sm: 520,
									xs: 520,
								},
								width: '100%',
							}}
						>
							<DataGrid
								rows={rows1}
								columns={columns}
								rowHeight={42}
								columnHeaderHeight={40}
								initialState={{
									pagination: {
										paginationModel: {
											pageSize: 10,
										},
									},
								}}
								pageSizeOptions={[5, 10, 50, 100]}
								disableRowSelectionOnClick
								sx={gridSx}
								slotProps={{
									pagination: { labelRowsPerPage: 'Rows per page:' },
								}}
							/>
						</Box>
					</Grid>
				)}
				{/* add appointment */}
				<Modal
					open={open}
					onClose={handleCloseModal}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
				>
					<Box sx={style}>
						<Box
							sx={{
								width: '100%',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'space-between',
								px: 2,
								height: 44,
								borderBottom: '1px solid #dce6f3',
							}}
						>
							<Typography
								id="modal-modal-title"
								sx={{
									fontFamily: 'Poppins',
									fontSize: '18px',
									fontWeight: 700,
									color: '#172d58',
								}}
							>
								Add Appointment
							</Typography>
							<Cancel
								sx={{ cursor: 'pointer', color: '#172d58' }}
								onClick={() => {
									handleCloseModal();
									setInvalidInfo(false);
									setappoitment({
										patient_id: '',
										provider_id: '',
										AppointmentDate: dayjs(selectedDate),
										location_id: '',
										Status: 'P',
										Reason: '',
									});
								}}
							/>
						</Box>
						{invalidInfo && (
							<Box
								display={
									appointment?.patient_id === ''
										? ''
										: appointment?.provider_id === ''
											? ''
											: appointment?.Status === ''
												? ''
												: appointment?.Reason === ''
													? ''
													: appointment?.AppointmentDate == 'Invalid Date'
														? ''
														: appointment?.location_id === ''
															? ''
															: 'none'
								}
							>
								<Alert variant="filled" severity="error">
									Please Fill all Information!
								</Alert>
							</Box>
						)}
						<Grid container spacing={1.5} sx={{ p: 2 }}>
							<Grid item xs={12} md={4}>
								<Typography sx={modalLabelSx}>Select Patient</Typography>
								<Autocomplete
									id="patient"
									name="patient"
									disableClearable
									options={patientList}
									getOptionLabel={(optionsParam) => optionsParam?.Name}
									onChange={(event, optionsParam) => {
										setappoitment((prev) => ({
											...prev,
											patient_id: optionsParam?.patient_id,
											provider_id: (patientList?.filter(
												(items) => items?.patient_id === optionsParam?.patient_id
											))[0]?.providerid,
											location_id: (patientList?.filter(
												(items) => items?.patient_id === optionsParam?.patient_id
											))[0]?.locationid,
										}));
									}}
									renderInput={(params) => (
										<TextField
											name="patient"
											{...params}
											placeholder="Select Patient"
											size="small"
											sx={modalControlSx}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12} md={4}>
								<Typography sx={modalLabelSx}>Provider Name</Typography>
								<FormControl fullWidth size="small" sx={modalControlSx}>
									<Select
										defaultValue=""
										displayEmpty
										MenuProps={modalMenuProps}
										value={appointment?.provider_id}
										onChange={(e) =>
											setappoitment((prev) => ({
												...prev,
												provider_id: e.target.value,
											}))
										}
									>
										<MenuItem value="" sx={{ color: '#8a9ab5' }}>
											Select Provider
										</MenuItem>
										{mappingProviderList?.map((item, index) => (
											<MenuItem key={index} value={item?.providerId}>
												{item?.name}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={4}>
								<Typography sx={modalLabelSx}>Appointment Status</Typography>
								<FormControl fullWidth size="small" sx={modalControlSx}>
									<Select
										defaultValue=""
										displayEmpty
										MenuProps={modalMenuProps}
										value={appointment?.Status}
										name="Status"
										onChange={(e) => {
											setappoitment((prev) => ({
												...prev,
												Status: e.target.value,
											}));
										}}
									>
										<MenuItem value="" sx={{ color: '#8a9ab5' }}>
											Select Status
										</MenuItem>
										<MenuItem value={'C'}>Completed</MenuItem>
										<MenuItem value={'D'}>Dismissed</MenuItem>
										<MenuItem value={'O'}>Other</MenuItem>
										<MenuItem value={'P'}>Pending</MenuItem>
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={6}>
								<Typography sx={modalLabelSx}>Location</Typography>
								<FormControl fullWidth size="small" sx={modalControlSx}>
									<Select
										defaultValue=""
										displayEmpty
										MenuProps={modalMenuProps}
										value={appointment?.location_id}
										name="modallocation"
										onChange={(e) => {
											setappoitment((prev) => ({
												...prev,
												location_id: e.target.value,
											}));
										}}
									>
										<MenuItem value="" sx={{ color: '#8a9ab5' }}>
											Select Location
										</MenuItem>
										{location?.map((items, index) => (
											<MenuItem key={index} value={items?.id}>
												{items?.Name}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={6}>
								<Typography sx={modalLabelSx}>Appointment Date & Time</Typography>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DemoContainer components={['DateTimePicker']} sx={{ p: 0 }}>
										<DemoItem>
											<DateTimePicker
												orientation="portrait"
												disablePast
												size="small"
												slotProps={{
													textField: {
														size: 'small',
														placeholder: 'MM/DD/YYYY hh:mm AM/PM',
														sx: modalControlSx,
													},
												}}
												sx={{ width: '100%' }}
												value={selectedDate}
												onChange={(nValue) => {
													setselectedDate(nValue);
													setappoitment((prev) => ({
														...prev,
														AppointmentDate: dayjs(nValue).format(
															'YYYY-MM-DDTHH:mm:ss'
														),
													}));
												}}
											/>
										</DemoItem>
									</DemoContainer>
								</LocalizationProvider>
							</Grid>
							<Grid item xs={12}>
								<Typography sx={modalLabelSx}>Reason</Typography>
								<Box
									component="textarea"
									name="Reason"
									placeholder="Enter Reason..."
									value={appointment?.Reason}
									onChange={(e) =>
										setappoitment((prev) => ({
											...prev,
											Reason: e.target.value,
										}))
									}
									sx={{
										width: '100%',
										minHeight: 92,
										resize: 'vertical',
										border: '1px solid #d6e2f2',
										borderRadius: '8px',
										padding: '12px 14px',
										fontFamily: 'Poppins',
										fontSize: '13px',
										color: '#122b55',
										outline: 'none',
										boxSizing: 'border-box',
										'&::placeholder': { color: '#8a9ab5' },
										'&:focus': { borderColor: '#2E68BA' },
									}}
								/>
							</Grid>
						</Grid>
						<Grid
							item
							sx={{
								display: 'flex',
								justifyContent: 'flex-end',
								gap: '5px',
								padding: '13px 8px 0px 8px',
							}}
							xs={12}
						>
							<Button
								onClick={() => {
									handleCloseModal();
									setInvalidInfo(false);
									setappoitment({
										patient_id: '',
										provider_id: '',
										AppointmentDate: dayjs(new Date()),
										location_id: '',
										Status: 'P',
										Reason: '',
									});
									setselectedDate(dayjs(new Date()));
								}}
							sx={{
								mb: 1,
								background: '#fff',
								border: '1px solid #cfd8e6',
								color: '#445273',
								fontFamily: 'Poppins',
								fontSize: '14px',
								fontWeight: 600,
								borderRadius: '10px',
								padding: '10px 26px',
								'&:hover': {
									background: '#f8fbff',
									border: '1px solid #cfd8e6',
								},
							}}
							>
								Cancel
							</Button>

							<Button
								// disabled={
								// 	appointment?.patient_id === ''
								// 		? true
								// 		: appointment?.provider_id === ''
								// 			? true
								// 			: appointment?.Status === ''
								// 				? true
								// 				: appointment?.Reason === ''
								// 					? true
								// 					: appointment?.AppointmentDate == 'Invalid Date'
								// 						? true
								// 						: appointment?.location_id === ''
								// 							? true
								// 							: false
								// }
							sx={{
								mb: 1,
								background: '#2E68BA',
								border: '1px solid #2E68BA',
								color: 'white',
								fontFamily: 'Poppins',
								fontSize: '14px',
								fontWeight: 600,
								borderRadius: '10px',
								padding: '10px 26px',
								'&:hover': {
									background: '#265aa8',
									border: '1px solid #265aa8',
								},
							}}
								onClick={() => {
									if (
										appointment?.patient_id === '' ||
										appointment?.provider_id === '' ||
										appointment?.Status === '' ||
										appointment?.Reason === '' ||
										appointment?.AppointmentDate == 'Invalid Date' ||
										appointment?.location_id === ''
									) {
										setInvalidInfo(true);
									} else {
										addNewAppointment(appointment);
									}
								}}
							>
								Add Appointment
							</Button>
						</Grid>
					</Box>
				</Modal>

				{/* update Modal for parent component is here */}

				<Modal
					open={updateModalopen}
					onClose={updateModalhandleClose}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
				>
					<Box sx={style}>
						<Box
							sx={{
								width: '100%',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'space-between',
								px: 2,
								height: 44,
								borderBottom: '1px solid #dce6f3',
							}}
						>
							<Typography
								id="modal-modal-title"
								sx={{
									fontFamily: 'Poppins',
									fontSize: '18px',
									fontWeight: 700,
									color: '#172d58',
								}}
							>
								Update Appointment
							</Typography>
							<Cancel
								sx={{ cursor: 'pointer', color: '#172d58' }}
								onClick={() => {
									updateModalhandleClose();
									setUpdateAppointmentData({
										patient_id: '',
										provider_id: '',
										AppointmentDate: dayjs(selectedDate),
										location_id: '',
										Status: 'P',
										Reason: '',
									});
								}}
							/>
						</Box>
						{
							// <Box
							// 	display={
							// 		updateAppointmentData?.patient_id === ''
							// 			? ''
							// 			: updateAppointmentData?.provider_id === ''
							// 				? ''
							// 				: updateAppointmentData?.Status === ''
							// 					? ''
							// 					: updateAppointmentData?.Reason === ''
							// 						? ''
							// 						: updateAppointmentData?.location_id === ''
							// 							? ''
							// 							: updateAppointmentData?.AppointmentDate ==
							// 								  'Invalid Date'
							// 								? ''
							// 								: 'none'
							// 	}
							// >
							// 	<Alert variant="filled" severity="error">
							// 		Please Fill all Information!
							// 	</Alert>
							// </Box>
						}
						<Grid container spacing={1.5} sx={{ p: 2 }}>
							<Grid item xs={12} md={4}>
								<Typography sx={modalLabelSx}>Select Patient</Typography>
								{patientList?.length > 0 && (
									<Autocomplete
										id="patient"
										name="patient"
										disableClearable
										options={patientList}
										getOptionLabel={(optionsParam) => optionsParam?.Name}
										onChange={(event, optionsParam) => {
											setUpdateAppointmentData((prev) => ({
												...prev,
												patient_id: optionsParam?.patient_id,
											}));
										}}
										defaultValue={patientList?.find(
											(items) =>
												items?.patient_id ===
												updateAppointmentData?.patient_id?.toString()
										)}
										renderInput={(params) => (
											<TextField
												name="patient"
												{...params}
												placeholder="Select Patient"
												size="small"
												sx={modalControlSx}
											/>
										)}
									/>
								)}
							</Grid>
							<Grid item xs={12} md={4}>
								<Typography sx={modalLabelSx}>Provider Name</Typography>
								<FormControl fullWidth size="small" sx={modalControlSx}>
									<Select
										defaultValue=""
										displayEmpty
										MenuProps={modalMenuProps}
										value={updateAppointmentData?.provider_id}
										onChange={(e) =>
											setUpdateAppointmentData((prev) => ({
												...prev,
												provider_id: e.target.value,
											}))
										}
									>
										<MenuItem value="" sx={{ color: '#8a9ab5' }}>
											Select Provider
										</MenuItem>
										{mappingProviderList?.map((item, index) => (
											<MenuItem key={index} value={item?.providerId}>
												{item?.name}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={4}>
								<Typography sx={modalLabelSx}>Appointment Status</Typography>
								<FormControl fullWidth size="small" sx={modalControlSx}>
									<Select
										defaultValue=""
										displayEmpty
										MenuProps={modalMenuProps}
										value={updateAppointmentData?.Status}
										name="Status"
										onChange={(e) => {
											setUpdateAppointmentData((prev) => ({
												...prev,
												Status: e.target.value,
											}));
										}}
									>
										<MenuItem value="" sx={{ color: '#8a9ab5' }}>
											Select Status
										</MenuItem>
										<MenuItem value={'C'}>Completed</MenuItem>
										<MenuItem value={'D'}>Dismissed</MenuItem>
										<MenuItem value={'O'}>Other</MenuItem>
										<MenuItem value={'P'}>Pending</MenuItem>
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={6}>
								<Typography sx={modalLabelSx}>Location</Typography>
								<FormControl fullWidth size="small" sx={modalControlSx}>
									<Select
										defaultValue=""
										displayEmpty
										MenuProps={modalMenuProps}
										value={updateAppointmentData?.location_id}
										name="modallocation"
										onChange={(e) => {
											setUpdateAppointmentData((prev) => ({
												...prev,
												location_id: e.target.value,
											}));
										}}
									>
										<MenuItem value="" sx={{ color: '#8a9ab5' }}>
											Select Location
										</MenuItem>
										{location?.map((items, index) => (
											<MenuItem key={index} value={items?.id}>
												{items?.Name}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={6}>
								<Typography sx={modalLabelSx}>Appointment Date & Time</Typography>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DemoContainer components={['DateTimePicker']} sx={{ p: 0 }}>
										<DemoItem>
											<MobileDateTimePicker
												disablePast
												size="small"
												slotProps={{
													textField: {
														size: 'small',
														placeholder: 'MM/DD/YYYY hh:mm AM/PM',
														sx: modalControlSx,
													},
												}}
												sx={{ width: '100%' }}
												value={updateDate}
												onChange={(nValue) => {
													setUpdateDate(nValue);
													setUpdateAppointmentData((prev) => ({
														...prev,
														AppointmentDate: dayjs(nValue).format(
															'YYYY-MM-DDTHH:mm:ss'
														),
													}));
												}}
											/>
										</DemoItem>
									</DemoContainer>
								</LocalizationProvider>
							</Grid>
							<Grid item xs={12}>
								<Typography sx={modalLabelSx}>Reason</Typography>
								<Box
									component="textarea"
									name="Reason"
									placeholder="Enter Reason..."
									value={updateAppointmentData?.Reason}
									onChange={(e) =>
										setUpdateAppointmentData((prev) => ({
											...prev,
											Reason: e.target.value,
										}))
									}
									sx={{
										width: '100%',
										minHeight: 92,
										resize: 'vertical',
										border: '1px solid #d6e2f2',
										borderRadius: '8px',
										padding: '12px 14px',
										fontFamily: 'Poppins',
										fontSize: '13px',
										color: '#122b55',
										outline: 'none',
										boxSizing: 'border-box',
										'&::placeholder': { color: '#8a9ab5' },
										'&:focus': { borderColor: '#2E68BA' },
									}}
								/>
							</Grid>
						</Grid>
						<Grid
							item
							sx={{
								display: 'flex',
								justifyContent: 'flex-end',
								gap: '5px',
								padding: '13px 8px 0px 8px',
							}}
							xs={12}
						>
							<Button
								onClick={() => {
									updateModalhandleClose();
									setUpdateAppointmentData({
										patient_id: '',
										provider_id: '',
										AppointmentDate: dayjs(selectedDate),
										location_id: '',
										Status: 'P',
										Reason: '',
									});
								}}
							sx={{
								mb: 1,
								background: '#fff',
								border: '1px solid #cfd8e6',
								color: '#445273',
								fontFamily: 'Poppins',
								fontSize: '14px',
								fontWeight: 600,
								borderRadius: '10px',
								padding: '10px 26px',
								'&:hover': {
									background: '#f8fbff',
									border: '1px solid #cfd8e6',
								},
							}}
							>
								Cancel
							</Button>

							<Button
								disabled={
									updateAppointmentData?.patient_id === ''
										? true
										: updateAppointmentData?.provider_id === ''
											? true
											: updateAppointmentData?.Status === ''
												? true
												: updateAppointmentData?.Reason === ''
													? true
													: // : updateAppointmentData?.location_id === ''
														// 	? true
														// 	: updateAppointmentData?.AppointmentDate ==
														// 		  'Invalid Date'
														// 		? true
														false
								}
							sx={{
								mb: 1,
								background: '#2E68BA',
								border: '1px solid #2E68BA',
								color: 'white',
								fontFamily: 'Poppins',
								fontSize: '14px',
								fontWeight: 600,
								borderRadius: '10px',
								padding: '10px 26px',
								'&:hover': {
									background: '#265aa8',
									border: '1px solid #265aa8',
								},
							}}
								onClick={() => {
									updateAppointmentInfo(appointmentID, updateAppointmentData);
								}}
							>
								Update Appointment
							</Button>
						</Grid>
					</Box>
				</Modal>

				{/* Delete Modal */}
				<Modal
					open={openDeleteModal?.deleteModalOpen}
					onClose={handleCloseDeleteModal}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
				>
					<Box
						sx={{
							position: 'absolute',
							top: '50%',
							left: '50%',
							transform: 'translate(-50%, -50%)',
							width: 'min(430px, calc(100vw - 32px))',
							bgcolor: '#fff',
							border: '1px solid #dce8f5',
							borderRadius: '10px',
							boxShadow: '0 18px 45px rgba(15, 23, 42, 0.18)',
							outline: 'none',
							overflow: 'hidden',
						}}
					>
						<Box display={'flex'} justifyContent={'flex-end'} sx={{ p: '12px 12px 0' }}>
							<Cancel
								sx={{ cursor: 'pointer', color: '#64748b', fontSize: '20px' }}
								onClick={() => {
									handleCloseDeleteModal();
								}}
							/>
						</Box>
						<Box display={'flex'} flexDirection={'column'} alignItems="center" sx={{ px: 3, pt: 1, pb: 3 }}>
							<Box
								sx={{
									width: 74,
									height: 74,
									borderRadius: '50%',
									background: '#fff1f2',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									mb: 2,
								}}
							>
								<Box
									sx={{
										width: 52,
										height: 52,
										borderRadius: '50%',
										background: '#ffe4e6',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
									}}
								>
									<DeleteIcon sx={{ color: '#ef4444', fontSize: '28px' }} />
								</Box>
							</Box>
							<Typography
								id="modal-modal-title"
								align="center"
								component="h2"
								sx={{
									fontFamily: 'Poppins',
									fontSize: '15px',
									fontWeight: 600,
									color: '#1f2937',
									mb: 1,
								}}
							>
								Are you sure you want to delete this appointment?
							</Typography>
							<Typography
								align="center"
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: 700,
									color: '#005eff',
									lineHeight: 1.4,
									wordBreak: 'break-word',
								}}
							>
								{openDeleteModal?.deletingName}
							</Typography>
						</Box>
						<Box
							sx={{
								display: 'grid',
								gridTemplateColumns: '1fr 1fr',
								gap: 1.5,
								px: 3,
								py: 2.5,
								borderTop: '1px solid #edf2f8',
							}}
						>
							<Button
								variant="contained"
								startIcon={<Cancel sx={{ fontSize: '18px' }} />}
								sx={{
									height: '40px',
									minWidth: 0,
									borderRadius: '6px',
									border: '1px solid #cfd9e8',
									backgroundColor: '#fff',
									color: '#344054',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 700,
									textTransform: 'none',
									boxShadow: 'none',
									'&:hover': {
										backgroundColor: '#f8fafc',
										borderColor: '#b9c6d8',
										boxShadow: 'none',
									},
								}}
								onClick={handleCloseDeleteModal}
							>
								No
							</Button>
							<Button
								variant="contained"
								startIcon={<CheckCircleOutlineIcon sx={{ fontSize: '18px' }} />}
								sx={{
									height: '40px',
									minWidth: 0,
									borderRadius: '6px',
									backgroundColor: '#2f6edb',
									color: '#fff',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 700,
									textTransform: 'none',
									boxShadow: '0 4px 12px rgba(47, 110, 219, 0.24)',
									'&:hover': {
										backgroundColor: '#245fc5',
										boxShadow: '0 4px 12px rgba(47, 110, 219, 0.24)',
									},
								}}
								onClick={() => {
									updateAppointmentInfo(openDeleteModal?.deletingId, {
										Deleted: true,
									});
								}}
							>
								Yes
							</Button>
						</Box>
					</Box>
				</Modal>

				{/* SnackBar */}
				<Snackbar
					open={openSnackbar}
					autoHideDuration={1800}
					onClose={handleCloseSnackbar}
					anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
				>
					<Alert
						onClose={handleCloseSnackbar}
						severity={!postSucessfully ? 'error' : 'success'}
						variant="filled"
						sx={{
							width: '100%',
							height: '3.5rem',
							textAlign: 'center',
							fontSize: '1.1rem',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						action={
							<React.Fragment>
								<span
									onClick={handleCloseSnackbar}
									style={{
										cursor: 'pointer',
										m: 'auto 0',
										fontSize: '13px',
										color: 'rgb(231, 231, 231)',
									}}
								>
									Close
								</span>
							</React.Fragment>
						}
					>
						{!postSucessfully ? 'Error!' : 'Appointment Added Successfully!'}
					</Alert>
				</Snackbar>

				{/* Child Component SnackBar that showing on update of Appointment */}
				<Snackbar
					open={updateAppointmentSnackbar}
					autoHideDuration={1800}
					onClose={() => {
						setupdateAppointmentSnackbar(false);
					}}
					anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
				>
					<Alert
						onClose={() => {
							setupdateAppointmentSnackbar(false);
						}}
						severity={'success'}
						variant="filled"
						sx={{
							width: '100%',
							height: '3.5rem',
							textAlign: 'center',
							fontSize: '1.1rem',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						action={
							<React.Fragment>
								<span
									onClick={() => setupdateAppointmentSnackbar(false)}
									style={{
										cursor: 'pointer',
										m: 'auto 0',
										fontSize: '13px',
										color: 'rgb(231, 231, 231)',
									}}
								>
									Close
								</span>
							</React.Fragment>
						}
					>
						{deleteAppointment
							? `Appointment Deleted Successfully!`
							: `Appointment Updated Successfully!`}
					</Alert>
				</Snackbar>
			</Grid>
		</ThemeProvider>
	);
}

export default ScheduleAppointment;
